import { GlobalBannerDynamic } from '@frontend/global-info-banner';
import { useTranslation } from '@frontend/i18n';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { usePreference } from '@frontend/user-preferences';

export const NotificationBanner = () => {
  const { t } = useTranslation('payments');
  const { navigate } = useSettingsNavigate();
  const [bannerDismissed, setBannerDismissed] = usePreference('PaymentsReceiptSettingsBannerDismissed');

  return (
    !bannerDismissed && (
      <GlobalBannerDynamic
        id='payments-receipt-settings-banner'
        type='info'
        title={t('Choose when receipts are sent')}
        message={t(
          'Receipts are automatically sent once a request is paid. To change this, navigate to Receipt Settings in Payments > General Settings.'
        )}
        action={{
          label: t('Adjust Settings'),
          onClick: () => navigate({ to: '/payments/general-settings' }),
        }}
        isDismissible={true}
        onDismiss={() => setBannerDismissed(true)}
      />
    )
  );
};
